import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isTutorialActive: false,
  currentStep: 0,
  navigating: false,
  direction: "",
  controlsPosition: "below",
  isLoading: true,
  activeDropdown: null,
};

const tutorialSlice = createSlice({
  name: "tutorial",
  initialState,
  reducers: {
    startTutorial: (state) => {
      state.isTutorialActive = true;
      state.currentStep = 0;
      state.navigating = false;
      state.direction = "";
      state.controlsPosition = "below";
      state.isLoading = false;
      state.activeDropdown = null;
    },
    stopTutorial: (state) => {
      state.isTutorialActive = false;
      state.currentStep = 0;
      state.navigating = false;
      state.direction = "";
      state.controlsPosition = "below";
      state.isLoading = false;
      state.activeDropdown = null;
    },
    nextStep: (state) => {
      state.currentStep += 1;
      state.activeDropdown = null;
      state.direction = "next";
    },
    prevStep: (state) => {
      state.currentStep -= 1;
      state.activeDropdown = null;
    },
    setNavigating: (state, action) => {
      state.navigating = action.payload;
    },
    setDirection: (state, action) => {
      state.direction = action.payload;
    },
    setControlsPosition: (state, action) => {
      state.controlsPosition = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setActiveDropdown: (state, action) => {
      state.activeDropdown = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
  },
});

export const {
  startTutorial,
  stopTutorial,
  nextStep,
  prevStep,
  setNavigating,
  setDirection,
  setControlsPosition,
  setIsLoading,
  setActiveDropdown,
  setCurrentStep,
} = tutorialSlice.actions;

export default tutorialSlice.reducer;
